import { useSearchParams } from 'react-router-dom'
import { PageChrome } from '@/components/gg/chrome'
import { Record } from '@/pages/Record'

/**
 * Record (/app/record, ?story=<id> opens the camera on that story).
 *
 * Brian's after/record.html v3.1 and the Oct 22 commits (RecordStudio): the
 * camera is full screen over the phone bars; on a computer the sidebar stays
 * and Record opens wide 16:9, with Reel 9:16 a tap away.
 */
export function RecordPage() {
  const [params] = useSearchParams()
  const open = !!params.get('story')
  return (
    <>
      <PageChrome title="Record" bars={!open} back />
      <Record />
    </>
  )
}
